// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ss0X","search":"Settings_search__3xU-j","filter":"Settings_filter__3OcxH"};